import {useQuery} from 'react-query';
import {getBasketCount} from './getBasket';

const useGetBasketCount = () => {
  const {data, isLoading, refetch} = useQuery<number>(
    ['get-basket-count'],
    getBasketCount,
  );

  return {data, isLoading, refetch};
};

export default useGetBasketCount;
